import React from "react";
import { Styles } from "./styles";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
} from "chart.js";

// Register the required Chart.js components
ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);

const Employees = ({ usersStats }) => {
  // Map the API data to the chart data format
  const labelsMap = {
    verified: "Verified",
    not_verified: "Not Verified",
    blocked: "Blocked",
  };

  // Generate labels and data dynamically
  const labels = usersStats.map(
    (stat) => labelsMap[stat.status] || stat.status
  );
  const dataCount = usersStats.map((stat) => stat.count);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Users Statistics",
        data: dataCount,
        backgroundColor: [
          "#114787",
          "#A3C4DC",
          "#d71814",
        ],
        borderColor: ["#114787", "#A3C4DC", "#d71814"],
        borderWidth: 1,
      },
    ],
  };

  // Options for the Bar Chart
  const options = {
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <Styles>
      <div
        style={{
          width: "300px",
          height: "300px",
          margin: "0 auto",
          marginTop: "20px",
        }}
      >
        <div className="title mb-2">{data?.datasets[0]?.label}</div>
        <Bar data={data} options={options} />
      </div>
    </Styles>
  );
};

export default Employees;
